export const getAnnotationsPermission = (date: string, now: Date, allowEditAnnotations: boolean) => {
    const londonTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/London' }))

    // Get today's date in the same format as your date string
    const today = londonTime.toLocaleDateString('en-CA')

    const isNightShiftNextDay = londonTime.getHours() < 5

    // Also get yesterday's date for the extended permission window
    const yesterday = new Date(londonTime.getTime() - 24 * 60 * 60 * 1000).toLocaleDateString('en-CA')

    // If it's before 5am, also allow permissions for yesterday's content
    const hasPermission = date === today || (isNightShiftNextDay && date === yesterday)

    return hasPermission ? (allowEditAnnotations ? 'edit' : 'view') : 'none'
}
